"use client";

// Counts one visit to a business (its page or one of its item pages) per visitor per day (docs/MARKETPLACE_TRUST_2026-11-04.md).
// It sends after the page has been visible for 2 seconds, once per business per day in this browser, with the sign-in
// header so the server can leave out the business's own staff. Nothing is polled.
import { useEffect } from "react";
import { getAuthHeaders } from "@/lib/auth";

export default function MarketplaceViewBeacon({ partnerId }: { partnerId: number }) {
  useEffect(() => {
    if (!(partnerId > 0)) return;
    const key = `cybo-view:${partnerId}:${new Date().toDateString()}`;
    try { if (window.localStorage.getItem(key)) return; } catch { /* storage blocked: the server still deduplicates */ }
    let timer = 0;
    let sent = false;
    const send = () => {
      if (document.visibilityState !== "visible" || timer || sent) return;
      timer = window.setTimeout(() => {
        sent = true;
        try { window.localStorage.setItem(key, "1"); } catch { /* ignore */ }
        void fetch("/api/v1/public/business-view", { method: "POST", headers: getAuthHeaders({ "Content-Type": "application/json" }),
          body: JSON.stringify({ partner_id: partnerId }), keepalive: true }).catch(() => undefined);
      }, 2000);
    };
    const onVisibility = () => {
      if (document.visibilityState === "visible") send();
      else { window.clearTimeout(timer); timer = 0; }
    };
    send();
    document.addEventListener("visibilitychange", onVisibility);
    return () => { document.removeEventListener("visibilitychange", onVisibility); window.clearTimeout(timer); };
  }, [partnerId]);
  return null;
}
